import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { IEnvironment } from 'src/environments/environment.model';

import { SettingsService } from 'src/app/modules/core/services/settings.service';

import { withSpinner } from 'src/app/modules/shared/extensions/withSpinner.extension';
import { UnsubscribeOnDestroy } from 'src/app/modules/shared/utilities/unsubscribe-on-destroy';
import { TermsAndConditions } from 'src/app/modules/core/models/terms-and-conditions.model';

@Injectable({
	providedIn: 'root'
})

export class TermsAndConditionsService extends UnsubscribeOnDestroy {
	private settings!: IEnvironment;
	
	constructor(private _http: HttpClient,
		settingsService: SettingsService) {
		super();

		settingsService.getSettings().pipe(
			this.takeUntilDestroyed()
		).subscribe(settings => {
			this.settings = settings;
		});
	}

	getTermsAndConditions(): Observable<TermsAndConditions> {
		const url = `${this.settings?.apiUrl}TermsAndConditions`;

		return withSpinner(this._http).get<TermsAndConditions>(url);
	}

	acknowledgeTermsAndConditions(publishDate: string): Observable<TermsAndConditions> {
		const url = `${this.settings?.apiUrl}TermsAndConditions`;
		const params: { publishDate: string } = { publishDate };

		return withSpinner(this._http).put<TermsAndConditions>(url, null, { params });
	}
}